export default {
    home:'الرئيسية',
    gallery:'صور',
    files:'ملفات',
    file:'ملف',
    download:'تحميل',
    downloads:'تحميلات',
    upload:'اضافة صورة',
    music:'موسيقى',
    videos:'مقاطع فيديو',
    books:'كتب',
    settings:'إعدادات',
    games:'العاب',
    categories:'أقسام',
    search_placeholder:'بحث : ملف ، موسيقى ، مقاطع فيديو ، اعضاء والمزيد..',
    theme:'التصميم',
    language:'اللغة',
    darkmode:'الوضع الغامق',
    lightmode:'الوضع الفاتح',
    username:'اسم المستخدم',
    password:'كلمة السر',
}